import React, { Component, Fragment, useEffect, useState } from "react";
import { Col, Row, Card, Form, Button } from "@themesberg/react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { getcontactLogin } from "../../Features/contactus/contactusSlice";
import { useCustomizeContext } from "../../context/index";


import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useTranslation, I18nextProvider } from "react-i18next";

const Contactus = (props) => {

   const { t, i18n } = useTranslation();

   let dispatch = useDispatch();

   const {
      loader: {
         setLoading,
      },
      languageContext: {
         changeLanguageRes,
      },

      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);

   let navigate = useNavigate();

   const ContactSchema = yup.object().shape({
      name: yup.string().required(`${t('Name is required')} !`).min(3, `${t('Name Must be  3 Characters long')} !`),
      email: yup.string().email(`${t('Invalid Email')} !`).required(`${t('Email is required')} !`),
      description: yup.string().required(`${t('Please type the description')} !`),
   });

   const { register, handleSubmit, watch, reset, clearErrors, formState: { errors } } = useForm({
      resolver: yupResolver(ContactSchema),
      mode: "onBlur",
   });

   const onSubmit = async (data) => {
      setLoading(true);
      let res = await dispatch(getcontactLogin(data));
      setTimeout(() => {
         if (res?.status === true) {
            setLoading(false);
            reset();
         }
         else {
            setLoading(false);
         }
      }, 500);
   }


   useEffect(() => {
      clearErrors();
   }, [changeLanguageRes]);

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   return (
      <Fragment>
         <Header />
         <div className="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">

                     <div className="transactionpage-maincnt">

                        <div class="contactpage-maincnt">
                           <div class="depsitpage-maincnt">
                              <h5 class="page-head">{t("Contact Us")}</h5>
                              <div class="deposit-form">
                                 <Form
                                    className="mt-4"
                                    onSubmit={handleSubmit(onSubmit)}
                                    autoComplete={"off"}
                                 >
                                    <div class="row">
                                       <div class="col-sm-6">
                                          <div class="form-group">
                                             <label>{t("Name")}</label>

                                             <input type="text" name="name"
                                                class="form-control" placeholder={t("EnterYourName")}
                                                {...register("name", { required: true })}
                                             />
                                             {errors.name && (
                                                <span class="text-danger">{errors.name.message}</span>)}
                                          </div>

                                       </div>
                                       <div class="col-sm-6">
                                          <div class="form-group">
                                             <label>{t("Email")}</label>
                                             <input type="text" placeholder={t("EnterYourEmail")} name="email" class="form-control"
                                                {...register("email", { required: true })} />

                                             {errors.email && (
                                                <span class="text-danger">{errors.email.message}</span>
                                             )}
                                          </div>
                                       </div>
                                       <div class="col-12">
                                          <div class="form-group">
                                             <label>{t("Description")}</label>
                                             <textarea name="description" id="" class="form-control"
                                                {...register("description", { required: true })} >
                                             </textarea>
                                             {errors.description && (
                                                <span class="text-danger">{errors.description.message}</span>
                                             )}
                                          </div>
                                       </div>
                                    </div>
                                    <div>
                                       <button type="submit" class="btn btn-primary submit-btn">{t("Send")}</button>
                                    </div>
                                 </Form>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );
}

export default Contactus;

